import { useState } from 'react'
import { baseURL } from '../config'

const usePostApi = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const postApi = async (url, data) => {
    const apiUrl = `${baseURL}${url}`
    try {
      setLoading(true)
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      setLoading(false)
      return await response.json()
    } catch (error) {
      setLoading(false)
      setError(error.message)
      throw error
    }
  }

  return { postApi, loading, error }
}

export default usePostApi
